import './TfrPanel.scss';

export { default } from './TfrPanel';
export { default as tfrPanelSchema } from './tfrPanelSchema';
